export const portfolio: Record<string, string> = {
  // Header
  'Back to feed': 'Nazad na feed',
  'My Portfolio': 'Moj portfolio',
  'Trade summary, performance metrics & history': 'Pregled trejdova, metrike učinka i istorija',
  'Failed to load portfolio data': 'Učitavanje podataka portfolija nije uspelo',

  // Stat cards
  'Total Trades': 'Ukupno trejdova',
  'all time': 'sve vreme',
  'closed trades': 'zatvorenih trejdova',
  'currently active': 'trenutno aktivno',
  'Closed P&L': 'Zatvoreni P&L',
  'wins / losses / breakeven': 'dobici / gubici / breakeven',

  // Charts
  'Outcome Distribution': 'Raspodela ishoda',
  'Win / Loss / BE / Open': 'Dobitak / Gubitak / BE / Otvoreno',
  'No trades yet': 'Još nema trejdova',
  'Win rate': 'Uspešnost',
  'Activity (Last 16 Weeks)': 'Aktivnost (poslednjih 16 nedelja)',
  'Trade ideas posted per week': 'Objavljene trejd ideje po nedelji',
  'ideas': 'ideja',
  'Market Focus': 'Fokus tržišta',

  // Trade tables
  'Closed Trades': 'Zatvoreni trejdovi',
  'No open trades': 'Nema otvorenih trejdova',
  'Post a trade idea to get started': 'Objavi trejd ideju za početak',
  'Go to Feed': 'Idi na feed',
  'No closed trades yet': 'Još nema zatvorenih trejdova',
  'Closed trades will appear here once you update their status': 'Zatvoreni trejdovi će se pojaviti ovde kada ažuriraš njihov status',
};
